import { checkResponse, get, patch, post, remove } from '../../api';

const url = `/api/subscription/account`;

export const loadSubscription = id =>
    checkResponse(get(`/api/subscriptions/${id}`));

export const loadUser = data => checkResponse(get(url, data));

export const addUsers = data => checkResponse(post(url, data));

export const updateUsers = data => checkResponse(patch(url, data));

export const removeUsers = data => checkResponse(remove(url, data));

export const convertToPersonal = data =>
    checkResponse(post(`${url}/migrate`, data));

export const resetPasswordUser = data =>
    checkResponse(post(`/api/subscription/account_restart`, data));
